// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components-kenya/calculator-kenya-homeloan/calculator-kenya-homeloan.component.scss
// module id = 720
// module chunks = 0